// initial state
const state = () => ({
    packages: [],
})

// getters
const getters = {
}

// actions
const actions = {
    getPackages: async({ commit }) => {
        let { data } = await axios.get('/package');
        commit('setPackages', data);
    },
}

// mutations
const mutations = {
    setPackages(state, payload) {
        state.packages = payload;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
